import withMetadataArgument from './withMetadataArgument.js'
import { getExtPrefix as _getExtPrefix } from '../../core/index.js'

export function getExtPrefix() {
	return withMetadataArgument(_getExtPrefix, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/getExtPrefix.js
// module id = 408
// module chunks = 0